<template>
	<scratch-card
		class="container-s shadow-box"
		:key="renderCount"
		:cardWidth="cardWidth"
        :cardHeight="cardHeight"
		:finishPercent="percentage"
		:imageUrl="`../../static/gold_quomi2.jpg`"
		:brushUrl="brushUrl"
		:forceReveal="forceReveal"
		@complete="$emit('update:percentage', percentage)"
	>
      	<div class="inner"> 
		   	<h1 :style="background">
		   		<p>{{ title }}</p>
		   	</h1>
	 	</div>	
    </scratch-card>
</template>
<script>

import ScratchCard from 'vue-scratchcard'

export default {
	data () {
		return {
			renderCount: 0,
			cardWidth: 300,
			cardHeight: 300,
			percentage: 60,
			brushUrl: require('../../assets/img/brush.png'),
			forceReveal: false,
		}
	},

	components: {
    	ScratchCard,
	},

	props: {
		alreadyAdded: {
			type: Boolean,
			default: false
		},

		title: {
			type: String,
			default: ''
		},

		image: {
			type: String,
			default: ''
		}
	},

	methods: {
		
	},

	watch: {
		'alreadyAdded' () {
			if (this.alreadyAdded) {
				this.forceReveal = true
			}
		}
	},

	computed: {
		background () {
			return {
				backgroundImage: 'url(' + this.image + ')',
				backgroundPosition: 'center center',
				backgroundSize: 'cover',
 	 			color: '#000',
 	 			display: 'table-cell',
 	 			verticalAlign: 'middle',
  				textAlign: 'center'
			}
		}
	},

	methods: {
		
	},

	mounted () {
		if (this.alreadyAdded) {
			this.forceReveal = true
		}
	}
}

</script>

<style scoped>

.container-s {
	border: 0px solid grey;
	position: relative;
	width: 300px;
	height: 300px;
	margin: 0 auto;
	-webkit-user-select: none;
	-moz-user-select: none;
	-ms-user-select: none;
	-o-user-select: none;
	user-select: none;
}

.container-s .canvas {
	position: absolute;
	top: 0;
	left: 0;
	border-radius: 4px;
}

.container-s .inner {
	display: table;
	width: 100%;
	height: 100%;
}

.container-s .inner h1 {
	position: relative;
	overflow: hidden;
	border-radius: 6px;
}

.container-s .inner h1 p {
	position: absolute;
    bottom: 0;
    width: 100%;
	font-size: 15px;
	padding: 10px;
	margin-top: 243px;
	margin-bottom: 0;
	background-color: white;
}

.container-s >>> .scratchcard-overlay {
	border-radius: 6px;
}
</style>
